import React from "react";
import { Box, Container, Grid } from "@mui/material";
import girlImg from "../../assets/images/callus.png";
import { CustomButton, HeadingText } from "../../utils/CustomTagComponents";

const Helpbanner = ({ tollfreenumber = "" }) => {
    return (
        <Box sx={{
            position: "relative", overflow: 'hidden', height: { xs: "auto", md: 320 }, display: "flex",
            bgcolor: "#002045", my: { xs: 2, sm: 2, md: 3 }
        }}>
            <Container>
                <Grid container alignItems="center" spacing={4}>
                    <Grid size={{ xs: 12, md: 6 }} sx={{
                        display: "flex",
                        justifyContent: { xs: "center", md: "flex-start" },
                    }}>
                        <Box
                            component="img"
                            src={girlImg}
                            alt="Call Support"
                            sx={{
                                width: "100%",

                                // ✅ Responsive height
                                height: {
                                    xs: 220,
                                    sm: 260,
                                    md: 320,
                                },

                                objectFit: "contain",

                                // ✅ Important for alignment
                                objectPosition: {
                                    xs: "center bottom",
                                    md: "left bottom",
                                },

                                display: "block",
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} mb={{ xs: 3, md: 0 }}>
                        <Box
                            sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}
                        >

                            <HeadingText
                                sx={{
                                    color: "#ffffff", fontSize: { xs: 16, md: 18 },
                                    lineHeight: '1.3 !important',
                                    mb: { xs: 1, md: 0 }
                                    // letterSpacing: '0px'
                                }}
                            >
                                Have Questions? We’re Here to Help
                            </HeadingText>

                            <HeadingText
                                component="div"
                                sx={{
                                    display: "flex",
                                    justifyContent:  { xs: 'center', md: 'flex-start' },   // ✅ center horizontally
                                    alignItems: "center",       // ✅ center vertically
                                    gap: "10px",
                                    color: "#ffffff",
                                    fontSize: { xs: 18, md: 30 },
                                    lineHeight: 1.5,
                                    whiteSpace: "nowrap",       // ✅ force single line
                                    textAlign: "center",
                                    width: "100%",              // ✅ full width for centering
                                }}
                                mb={2}
                            >
                                <span>Call us on</span>

                                {/* ICON */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 20,
                                        height: 20,
                                    }}
                                >
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 512 512"
                                        fill="currentColor"
                                    >
                                        <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                                    </svg>
                                </Box>

                                <span>{tollfreenumber}</span>
                            </HeadingText>


                            <a href="#contact">
                                <CustomButton variant="contained">
                                    Connect Now
                                </CustomButton>
                            </a>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Helpbanner;
